// APP
export const SET_CLIENT_BRAND = "SET_CLIENT_BRAND";

// ALERTS
export const SET_ALERT = "SET_ALERT";
export const SET_ALERT_VISIBILITY = "SET_ALERT_VISIBILITY";

// HEADER
export const CHANGE_LANG = "CHANGE_LANG";

// ACCOUNT
export const LOG_IN = "LOG_IN";
export const LOG_IN_ADMIN = "LOG_IN_ADMIN";
export const CHECK_ADMIN = "CHECK_ADMIN";
export const CREATE_ACCOUNT = "CREATE_ACCOUNT";
export const VERIFY_ACCOUNT = "VERIFY_ACCOUNT";
export const VERIFY_EDITED_ACCOUNT = "VERIFY_EDITED_ACCOUNT";
export const UPDATE_EDITED_ACCOUNT = "UPDATE_EDITED_ACCOUNT";
export const FETCH_USER = "FETCH_USER";
export const UPDATE_PREFERENCES = "UPDATE_PREFERENCES";
export const PASSWORD_RESET_STATUS = "PASSWORD_RESET_STATUS";
export const LOG_OUT = "LOG_OUT";

// LANGUAGE
export const FETCH_LANGUAGES = "FETCH_LANGUAGES";
export const FETCH_TRANSLATION = "FETCH_TRANSLATION";
export const UPDATE_LANGUAGE = "UPDATE_LANGUAGE";
export const VALIDATE_LANGUAGE_HASH = "VALIDATE_LANGUAGE_HASH";